export default "__VITE_ASSET__DA1V3Tap__"